export class ValueWithMultiplier {
  value: number;
  baseMultiplier?: number;
}
